export default class extends Controller {
  static targets = ["form", "fileField"]

  connect() {
    App.Helpers.addAjaxHandlers(this.formTarget, this.renderAssetRow.bind(this), this.addErrorMessages.bind(this))
  }

  renderAssetRow(event, response) {
    App.Helpers.replaceElement(this.element, response.html)
  }

  addErrorMessages(event, data) {
    const { errors } = JSON.parse(data.responseText)
    Object.keys(errors || {}).forEach(key => {
      const inputName = `asset[${key}]`
      const input = this.element.querySelector(`[name="${inputName}"]`)
      App.Helpers.appendBefore(this.errorBlockFor(errors[key]), input)
    })
  }

  errorBlockFor(message) {
    return `<div class="text-error">${message}</div>`
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-form-row-controller.js